import styled from 'styled-components';
import { Flex } from '../../Layout';
import { TypographyBase } from '../../Typography';
export const OptionsContainer = styled(Flex).withConfig({
  displayName: "OptionsContainer",
  componentId: "sc-17guujd-0"
})(["flex-direction:column;z-index:9999;"]);
export const FlagContainer = Flex;
export const Flag = TypographyBase;
export const TriggerWrapper = styled(Flex).attrs(props => ({
  style: {
    padding: props.padding,
    backgroundColor: props.backgroundColor,
    color: props.color,
    borderRadius: props.orderRadius,
    border: props.border,
    fontSize: props.fontSize,
    lineHeight: props.lineHeight
  }
})).withConfig({
  displayName: "TriggerWrapper",
  componentId: "sc-17guujd-1"
})(["align-items:baseline;position:relative;justify-content:space-between;align-items:center;width:100%;margin-right:0 !important;&&&{:hover{cursor:pointer;}}"]);
export const GenderOption = styled.div.attrs(props => ({
  style: {
    height: "".concat(props.size - 24, "px}"),
    transform: "translateY(".concat(props.start, "px)"),
    width: props.innerWidth
  }
})).withConfig({
  displayName: "GenderOption",
  componentId: "sc-17guujd-2"
})(["position:absolute;top:0;left:0;margin:12px;display:flex;align-items:center;font-family:inherit;&&&{:hover{cursor:pointer;}}"]);
export const InputWrapper = styled(Flex).withConfig({
  displayName: "InputWrapper",
  componentId: "sc-17guujd-3"
})(["&&&{position:relative;justify-content:space-between;align-items:center;width:100%;:hover{cursor:pointer;}}"]);
export const GenderRotationBox = styled.div.attrs(props => ({
  style: {
    paddingRight: props.isValid ? '34px' : '11px'
  }
})).withConfig({
  displayName: "GenderRotationBox",
  componentId: "sc-17guujd-4"
})(["&&&{:hover{cursor:pointer;}}"]);